$.newPhotoSwipe = function(pswpElement, items, thumbnail, index) {
    pswpElement = document.querySelectorAll(pswpElement)[0];

    // define options (if needed)
    var options = {
        getThumbBoundsFn: function() {
            // get window scroll Y
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            // optionally get horizontal scroll

            // get position of element relative to viewport
            var rect = thumbnail.getBoundingClientRect();

            // w = width
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};


            // Good guide on how to get element coordinates:
            // http://javascript.info/tutorial/coordinates
        },
        history: false,
        focus: false,
        index: index || 0
    };

    if (!window.PhotoSwipe) {
        return;
    }

    // Initializes and opens PhotoSwipe
    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

    gallery.init();
};

$.photoSwipeCallable = function($this, pswpElement) {
    $this = $($this);

    var imgGallery = $this.data('gallery');

    var selector = $this.data('image');

    // build items array
    var items = [],
        index = 0;

    var addItem = function($this) {
        $this = $($this);

        var src = $this.attr('href');

        var sizes = $this.data('sizes');

        if (!sizes) {
            return;
        }

        sizes = sizes.split('x');

        items.push({
            src: src,
            msrc: $this.find('img').attr('src') || src,
            w: sizes[0],
            h: sizes[1]
        });
    };

    if (imgGallery) {
        var gallery = $('[data-gallery="' + imgGallery + '"]');

        gallery.each(function() {
            addItem(this);
        });

        index = gallery.index($this);
    } else {
        addItem($this);
    }

    var original = null;

    switch (selector) {
        case 'prev':
            original = $this.prev()[0];
            break;
        case 'next':
            original = $this.next()[0];
            break;
        default:
            if (selector) {
                original = $(selector)[0];
            } else {
                original = $this.find('img')[0] || $this[0];
            }
    }

    $.newPhotoSwipe(pswpElement, items, original, index);
};

$.photoSwipe = function (el, pswpElement, doc) {
    if (doc) {
        $(doc).on('click', el, function(e) {
            e.preventDefault();

            $.photoSwipeCallable(this, pswpElement);
        });
    } else {
        $(el).click(function(e) {
            e.preventDefault();

            $.photoSwipeCallable(this, pswpElement);
        });
    }
};

$.fn.photoSwipe = function(pswpElement, doc) {
    $.photoSwipe(this, pswpElement, doc);
};

(function($, window, document, undefined) {
    var $window = $(window);

    $.fn.lazyload = function(options) {
        var elements = this;

        var settings = {
            threshold       : 0,
            failure_limit   : 0,
            replace_img     : true,
            event           : 'scroll',
            effect_callback : false,
            effect          : 'show',
            container       : null,
            data_attribute  : 'src',
            data_attribute_set  : 'srcset',
            //custom
            data_attribute_retina  : 'src-retina',
            skip_invisible  : true,
            appear          : null,
            load            : null,
            placeholder     : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC'
        };

        settings.container = settings.container || window;

        $.extend(settings, options);

        elements.each(function() {
            var self = this;

            var $self = $(self);

            self.loaded = false;

            /* If no src attribute given use data:uri. */
            if ($self.attr('src') === undefined || $self.attr('src') === false) {
                if ($self.is('img')) {
                    $self.attr('src', settings.placeholder);
                }
            }

            /* When appear is triggered load original image. */
            $self.one('appear', function() {
                if (!this.loaded) {
                    if (settings.appear) {
                        var elements_left = elements.length;
                        settings.appear.call(self, elements_left, settings);
                    }

                    var setLoaded = function(loaded) {
                        if (settings.effect_callback) {
                            settings.effect_callback(loaded);
                        } else if (settings.effect) {
                            loaded.hide();

                            loaded[settings.effect](settings.effect_speed);
                        }

                        self.loaded = true;

                        /* Remove image from array so it is not looped next time. */
                        var temp = $.grep(elements, function(element) {
                            return !element.loaded;
                        });
                        elements = $(temp);

                        if (settings.load) {
                            var elements_left = elements.length;
                            settings.load.call(self, elements_left, settings);
                        }
                    };

                    var original = $self.attr('data-' + (window.devicePixelRatio > 1 ? settings.data_attribute_retina : settings.data_attribute));

                    if (window.devicePixelRatio > 1 && !original) {
                        original = $self.attr('data-' + settings.data_attribute);
                    }

                    if (!original) {
                        return;
                    }

                    var originalSet = $self.attr('data-srcset');

                    var loadImage = null;

                    if (settings.replace_img && $self.is('img')) {
                        loadImage = $self.clone();

                        loadImage.bind('load', function() {
                            $self.replaceWith(loadImage);

                            setLoaded(loadImage);
                        });
                    } else {
                        loadImage = $('<img />').bind('load', function() {
                            //custom

                            if ($self.is('img')) {
                                $self.attr('srcset', originalSet);
                                $self.attr('src', original);
                            } else {
                                $self.css('background-image', 'url("' + original + '")');
                            }

                            setLoaded($self);
                        });
                    }

                    if (originalSet) {
                        loadImage.attr('srcset', originalSet);
                    }

                    loadImage.attr('src', original);
                }
            });

            /* When wanted event is triggered load original image */
            /* by triggering appear.                              */
            if (0 !== settings.event.indexOf('scroll')) {
                $self.bind(settings.event, function() {
                    if (!self.loaded) {
                        $self.trigger('appear');
                    }
                });
            }
        });

        function update() {
            var counter = 0;

            elements.each(function() {
                var $this = $(this);

                if (settings.skip_invisible && !$this.is(':visible')) {
                    return;
                }

                if ($.abovethetop(this, settings) ||
                    $.leftofbegin(this, settings)) {
                    /* Nothing. */
                } else if (!$.belowthefold(this, settings) &&
                    !$.rightoffold(this, settings)) {

                    $this.trigger('appear');

                    /* if we found an image we'll load, reset the counter */
                    counter = 0;
                } else {
                    if (++counter > settings.failure_limit) {
                        return false;
                    }
                }
            });

            if (!elements.length) {
                $(settings.container).unbind(settings.event, update);
            }
        }

        /* Fire one scroll event per scroll. Not one scroll event per image. */
        if (settings.event.split(' ').indexOf('scroll') > -1) {
            $(settings.container).bind(settings.event, update);
        }

        /* Check if something appears when window is resized. */
        $window.bind('load resize', update);

        update();

        /* With IOS5 force loading images when navigating with back button. */
        /* Non optimal workaround. */
        if ((/(?:iphone|ipod|ipad).*os 5/gi).test(navigator.appVersion)) {
            $window.bind('pageshow', function(event) {
                if (event.originalEvent && event.originalEvent.persisted) {
                    elements.each(function() {
                        $(this).trigger('appear');
                    });
                }
            });
        }

        return this;
    };

    /* Convenience methods in jQuery namespace.           */
    /* Use as  $.belowthefold(element, {threshold : 100, container : window}) */

    $.belowthefold = function(element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
        } else {
            fold = $(settings.container).offset().top + $(settings.container).height();
        }

        return fold <= $(element).offset().top - settings.threshold;
    };

    $.rightoffold = function(element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = $window.width() + $window.scrollLeft();
        } else {
            fold = $(settings.container).offset().left + $(settings.container).width();
        }

        return fold <= $(element).offset().left - settings.threshold;
    };

    $.abovethetop = function(element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = $window.scrollTop();
        } else {
            fold = $(settings.container).offset().top;
        }

        return fold >= $(element).offset().top + settings.threshold  + $(element).height();
    };

    $.leftofbegin = function(element, settings) {
        var fold;

        if (settings.container === undefined || settings.container === window) {
            fold = $window.scrollLeft();
        } else {
            fold = $(settings.container).offset().left;
        }

        return fold >= $(element).offset().left + settings.threshold + $(element).width();
    };

    $.inviewport = function(element, settings) {
        return !$.rightoffold(element, settings) && !$.leftofbegin(element, settings) &&
            !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
    };

    /* Custom selectors for your convenience.   */
    /* Use as $('img:below-the-fold').something() or */
    /* $('img').filter(':below-the-fold').something() which is faster */

    $.extend($.expr[':'], {
        'below-the-fold' : function(a) { return $.belowthefold(a, {threshold : 0}); },
        'above-the-top'  : function(a) { return !$.belowthefold(a, {threshold : 0}); },
        'right-of-screen': function(a) { return $.rightoffold(a, {threshold : 0}); },
        'left-of-screen' : function(a) { return !$.rightoffold(a, {threshold : 0}); },
        'in-viewport'    : function(a) { return $.inviewport(a, {threshold : 0}); },
        /* Maintain BC for couple of versions. */
        'above-the-fold' : function(a) { return !$.belowthefold(a, {threshold : 0}); },
        'right-of-fold'  : function(a) { return $.rightoffold(a, {threshold : 0}); },
        'left-of-fold'   : function(a) { return !$.rightoffold(a, {threshold : 0}); }
    });

})(jQuery, window, document);

(function($, doc, outer) {
    $.addOuterEvent = function(name, outerName) {
        // The "outer" event name.
        outerName = outerName || outer + name;

        // A jQuery object containing all elements to which the "outer" event is bound.
        var elements = $(),

        // The "originating" event, namespaced for easy unbinding.
            namespace = name + '.' + outerName + '-special-event';

        $.event.special[outerName] = {

            // This method gets called the first time this event
            // is bound to THIS particular element. It will be
            // called once and ONLY once for EACH element.
            setup: function() {
                // Add this element to the list of elements to which this "outer"
                // event is bound.
                elements = elements.add(this);

                // If this is the first element getting the event bound, bind a handler
                // to document to catch all corresponding "originating" events.
                if (elements.length === 1) {
                    $(doc).bind(namespace, handleEvent);
                }
            },

            // This method gets called when this event us unbound from THIS particular element.
            teardown: function() {
                // Remove this element from the list of elements to which this "outer" event is bound.
                elements = elements.not(this);

                // If this is the last element removed, remove the "originating" event
                // handler on document that powers this "outer" event.
                if (elements.length === 0) {
                    $(doc).unbind(namespace);
                }
            },

            // Called every time a "outer" event callback is bound to an element.
            add: function(handleObj) {
                var oldHandler = handleObj.handler;

                // This function is executed every time the event is triggered. This is
                // used to override the default event.target reference with one that is
                // more useful.
                handleObj.handler = function(event, elem) {
                    // Set the event object's .target property to the element that the
                    // user interacted with, not the element that the "outer" event was
                    // was triggered on.
                    event.target = elem;

                    // Execute the actual bound handler.
                    oldHandler.apply(this, arguments);
                };
            }
        };

        // When the "originating" event is triggered..
        function handleEvent(event) {
            // Iterate over all elements to which this "outer" event is bound.
            $(elements).each(function() {
                var element = $(this);

                // If this element isn't the element on which the event was triggered,
                // and this element doesn't contain said element, then said element is
                // considered to be outer, and the "outer" event will be triggered!
                if (this !== event.target && !element.has(event.target).length) {
                    // Use triggerHandler instead of trigger so that the "outer" event
                    // doesn't bubble. Pass in the "originating" event's .target so that
                    // the "outer" event.target can be overridden with something more
                    // meaningful.
                    element.triggerHandler(outerName, [event.target]);
                }
            });
        }
    };

    // All these events will get an "outer" event counterpart by default.
    $.map('click dblclick mousemove mousedown mouseup mouseover mouseout change select submit keydown keypress keyup'.split(' '), function(name) {
        $.addOuterEvent(name);
    });

    // Add mobile
    $.map('touchstart touchend touchcancel touchmove'.split(' '), function(name) {
        $.addOuterEvent(name);
    });

    // The focus and blur events are really focusin and focusout when it comes
    // to delegation, so they are a special case.
    $.addOuterEvent('focusin', outer + 'focus');
    $.addOuterEvent('focusout', outer + 'blur');
})(jQuery, document, 'outer');
